<template>
  <div>添加组织</div>
</template>

<script>
export default {

}
</script>

<style>

</style>